import React from "react";
import { CATEGORY_PILLS } from "../../constants/agentTenderChoices";

// Category pills (P1/P9) — Players / Coaches / Staffs / Others with per-pill
// counts. Shared by the browse feed and the "My requests" view so both drive
// the same `category` param + tab_counts (mapped server-side to
// tender_category + staff_role groups; the club N2 feed inherits it too).
//
// V2 UI rebuild (design doc 01): ONE horizontal nowrap row. Active pill is
// the filled #2283FF pill with its count inline at 75% opacity; inactive
// pills are white/bordered with the count in #94A3B8 — no count bubbles.
// `children` (the feed's Cards/List toggle) render right-aligned in the SAME
// row after a flex spacer, exactly like the artboard's category row.
const CategoryPills = ({
  activeCategory,
  onChange,
  counts,
  className = "mb-4",
  children = null,
}) => (
  <div
    className={`flex items-center gap-2 flex-nowrap overflow-x-auto ${className}`}
  >
    {CATEGORY_PILLS.map(({ key, label }) => {
      const isActive = key === activeCategory;
      const count = counts?.[key] ?? 0;
      return (
        <button
          key={key}
          type="button"
          onClick={() => onChange(key)}
          className={`flex-none text-[12.5px] px-[13px] py-1.5 rounded-full whitespace-nowrap transition-colors ${
            isActive
              ? "font-semibold bg-[#2283FF] text-white"
              : "font-medium bg-white border border-[#E2E8F0] text-[#475569] hover:border-gray-300"
          }`}
        >
          {label}{" "}
          <span className={isActive ? "opacity-75" : "text-[#94A3B8]"}>
            {count}
          </span>
        </button>
      );
    })}
    {children != null && (
      <>
        <span className="flex-1" />
        {children}
      </>
    )}
  </div>
);

export default CategoryPills;
